import { TileEntry } from "../../models/app/Tile";

export const MOCK_TILE_ENTRIES: TileEntry[] = [
  {
    "id": 1,
    "state": 0,
    "tile_id": 1,
    "title": "Quiz 1: Anatomische termen van positie",
    "type": "ASSIGNMENT"
  }, {
    "id": 2,
    "state": 0,
    "tile_id": 1,
    "title": "Quiz 2: Macro Anatomie",
    "type": "ASSIGNMENT"
  }, {
    "id": 3,
    "state": 0,
    "tile_id": 1,
    "title": "Quiz 3: Neurotransmitter systemen",
    "type": "ASSIGNMENT"
  }, {
    "id": 4,
    "state": 0,
    "tile_id": 1,
    "title": "Quiz 4: Micro anatomie",
    "type": "ASSIGNMENT"
  }, {
    "id": 5,
    "state": 0,
    "tile_id": 2,
    "title": "Assignment 1",
    "type": "ASSIGNMENT"
  }, {
    "id": 6,
    "state": 0,
    "tile_id": 2,
    "title": "Assignment 2",
    "type": "ASSIGNMENT"
  }, {
    "id": 7,
    "state": 0,
    "tile_id": 2,
    "title": "Assignment 3",
    "type": "ASSIGNMENT"
  }, {
    "id": 8,
    "state": 0,
    "tile_id": 3,
    "title": "College 1",
    "type": "ASSIGNMENT"
  }, {
    "id": 9,
    "state": 0,
    "tile_id": 3,
    "title": "College 2",
    "type": "ASSIGNMENT"
  }, {
    "id": 10,
    "state": 0,
    "tile_id": 3,
    "title": "College 3",
    "type": "ASSIGNMENT"
  }, {
    "id": 11,
    "state": 0,
    "tile_id": 3,
    "title": "College 4",
    "type": "ASSIGNMENT"
  }, {
    "id": 12,
    "state": 0,
    "tile_id": 3,
    "title": "College 5",
    "type": "ASSIGNMENT"
  }, {
    "id": 13,
    "state": 0,
    "tile_id": 3,
    "title": "College 6",
    "type": "ASSIGNMENT"
  }, {
    "id": 14,
    "state": 0,
    "tile_id": 3,
    "title": "College 7",
    "type": "ASSIGNMENT"
  }, {
    "id": 15,
    "state": 0,
    "tile_id": 3,
    "title": "College 8",
    "type": "ASSIGNMENT"
  }, {
    "id": 16,
    "state": 0,
    "tile_id": 3,
    "title": "College 9",
    "type": "ASSIGNMENT"
  }, {
    "id": 17,
    "state": 0,
    "tile_id": 3,
    "title": "College 10",
    "type": "ASSIGNMENT"
  }, {
    "id": 18,
    "state": 0,
    "tile_id": 3,
    "title": "College 11",
    "type": "ASSIGNMENT"
  }, {
    "id": 19,
    "state": 0,
    "tile_id": 3,
    "title": "College 12",
    "type": "ASSIGNMENT"
  }, {
    "id": 20,
    "state": 0,
    "tile_id": 3,
    "title": "College 13",
    "type": "ASSIGNMENT"
  }, {
    "id": 21,
    "state": 0,
    "tile_id": 3,
    "title": "College 14",
    "type": "ASSIGNMENT"
  }, {
    "id": 22,
    "state": 0,
    "tile_id": 3,
    "title": "College 15",
    "type": "ASSIGNMENT"
  }, {
    "id": 23,
    "state": 0,
    "tile_id": 3,
    "title": "College 16",
    "type": "ASSIGNMENT"
  }, {
    "id": 24,
    "state": 0,
    "tile_id": 3,
    "title": "College 17",
    "type": "ASSIGNMENT"
  }, {
    "id": 25,
    "state": 0,
    "tile_id": 3,
    "title": "College 18",
    "type": "ASSIGNMENT"
  }, {
    "id": 26,
    "state": 0,
    "tile_id": 3,
    "title": "College 19",
    "type": "ASSIGNMENT"
  }, {
    "id": 27,
    "state": 0,
    "tile_id": 3,
    "title": "College 20",
    "type": "ASSIGNMENT"
  }, {
    "id": 28,
    "state": 0,
    "tile_id": 3,
    "title": "College 21",
    "type": "ASSIGNMENT"
  }, {
    "id": 29,
    "state": 0,
    "tile_id": 3,
    "title": "College 22",
    "type": "ASSIGNMENT"
  }, {
    "id": 30,
    "state": 0,
    "tile_id": 4,
    "title": "WCFD8en9sept",
    "type": "ASSIGNMENT"
  }, {
    "id": 31,
    "state": 0,
    "tile_id": 4,
    "title": "WCpatho25of28sept",
    "type": "ASSIGNMENT"
  }, {
    "id": 32,
    "state": 0,
    "tile_id": 4,
    "title": "oefentoets1",
    "type": "ASSIGNMENT"
  }, {
    "id": 33,
    "state": 0,
    "tile_id": 4,
    "title": "WCpatho9okt",
    "type": "ASSIGNMENT"
  }, {
    "id": 34,
    "state": 0,
    "tile_id": 4,
    "title": "oefentoets2",
    "type": "ASSIGNMENT"
  }, {
    "id": 35,
    "state": 0,
    "tile_id": 4,
    "title": "WCFD12okt",
    "type": "ASSIGNMENT"
  }, {
    "id": 36,
    "state": 0,
    "tile_id": 4,
    "title": "WCFD19okt",
    "type": "ASSIGNMENT"
  }, {
    "id": 37,
    "state": 0,
    "tile_id": 5,
    "title": "Cijfers deeltoets 1",
    "type": "ASSIGNMENT"
  }, {
    "id": 38,
    "state": 0,
    "tile_id": 5,
    "title": "Cijfers deeltoets 2",
    "type": "ASSIGNMENT"
  }, {
    "id": 39,
    "state": 0,
    "tile_id": 5,
    "title": "Cijfer presentatie",
    "type": "ASSIGNMENT"
  }, {
    "id": 40,
    "state": 0,
    "tile_id": 5,
    "title": "Cijfer deeltoets 3",
    "type": "ASSIGNMENT"
  }
]